import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { useStaticQuery, graphql } from 'gatsby';
import ContextConsumer from '../../helpers/context';

const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  width: 100%;

  @media only screen and (max-width: 810px) {
    flex-direction: column-reverse;
    align-items: flex-start;
  }
`;

const ContactWrapper = styled.div`
  display: flex;
  @media only screen and (max-width: 810px) {
    flex-direction: column;
  }
`;

const Line = styled.div`
  display: flex;
  margin-right: 29px;

  &:last-of-type {
    margin-right: 0;
  }

  @media only screen and (max-width: 810px) {
    margin-right: 0;
    margin-bottom: 3px;
  }
`;

const Text = styled.h3`
  font-size: 16px;
  line-height: 1;

  @media only screen and (max-width: 810px) {
    font-size: 11px;
    line-height: 1;
  }
`;

const Copyrights = styled.div`
  @media only screen and (max-width: 810px) {
    margin-bottom: 3px;
    font-size: 11px;
    line-height: 1;
  }
`;

const Footer = ({ isEn }) => {
  const general = useStaticQuery(graphql`
    query footer {
      med {
        pl: pageContact(
          where: { id: "ckjtspcaw2okg0b53vcsq2p8a" }
          locales: pl_PL
        ) {
          address
          footerContactHeading
          heading2
          mapsUrl
          seoDescription
          email
        }
        en: pageContact(
          where: { id: "ckjtspcaw2okg0b53vcsq2p8a" }
          locales: en
        ) {
          address
          footerContactHeading
          heading2
          mapsUrl
          seoDescription
          email
        }
      }
    }
  `);

  const [data, setData] = useState(false);

  useEffect(() => {
    setData(isEn ? general.med.en : general.med.pl);
  }, [isEn]);



  return (
    <Wrapper>
      <ContactWrapper>
        <Line>
          <Text>{data.footerContactHeading}&nbsp;</Text>
          <Text as="a" href={`mailto:${data.email}`}>
            {data.email}
          </Text>
        </Line>

        <Line>
          <Text>{data.heading2}&nbsp;</Text>
          <Text as="a" href={data.mapsUrl} target="_blank">
            {data.address}
          </Text>
        </Line>
      </ContactWrapper>

      <Copyrights>© Mediocre</Copyrights>
    </Wrapper>
  );
};

const ConnectedFooter = () => {
  return (
    <ContextConsumer>
      {({ data, set }) => <Footer isEn={data.isEn} />}
    </ContextConsumer>
  );
};

export default ConnectedFooter;
